"use strict";

exports.__esModule = true;
exports.formatToTimeOnly = exports.formatToShortDayHour = exports.formatToSecondsOnly = exports.formatToDateTime = exports.formatToDateOnly = exports.formatDate = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SHORT_DAY_HOUR_FORMAT = "dd hh A";
var DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
var DATE_FORMAT = "YYYY-MM-DD";
var SIMPLE_TIME_FORMAT = "HH:mm";
var SECOND_FORMAT = ":ss";
var formatDate = exports.formatDate = function formatDate(date, timezone, date_format) {
  if (timezone) return (0, _momentTimezone["default"])(date).tz(timezone.name).format(date_format);
  return (0, _momentTimezone["default"])(date).format(date_format);
};
var formatToDateTime = exports.formatToDateTime = function formatToDateTime(date, timezone) {
  return formatDate(date, timezone, DATE_TIME_FORMAT);
};
var formatToTimeOnly = exports.formatToTimeOnly = function formatToTimeOnly(date, timezone) {
  return formatDate(date, timezone, SIMPLE_TIME_FORMAT);
};
var formatToSecondsOnly = exports.formatToSecondsOnly = function formatToSecondsOnly(date, timezone) {
  return formatDate(date, timezone, SECOND_FORMAT);
};
var formatToDateOnly = exports.formatToDateOnly = function formatToDateOnly(date, timezone) {
  return formatDate(date, timezone, DATE_FORMAT);
};
var formatToShortDayHour = exports.formatToShortDayHour = function formatToShortDayHour(date, timezone) {
  return formatDate(date, timezone, SHORT_DAY_HOUR_FORMAT);
};